// Photos are downscaled on the device before saving (SPEC.md §4.3 attachments).
const MAX_EDGE = 1600;
const QUALITY = 0.8;

/** A JPEG of `file` with its long edge at most 1600px, honouring EXIF orientation. */
export async function downscalePhoto(file: Blob): Promise<Uint8Array<ArrayBuffer>> {
  const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
  try {
    const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height));
    const width = Math.round(bitmap.width * scale);
    const height = Math.round(bitmap.height * scale);
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    if (!context) throw new Error('This browser can’t process photos.');
    context.drawImage(bitmap, 0, 0, width, height);
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', QUALITY));
    if (!blob) throw new Error('The photo couldn’t be saved.');
    return new Uint8Array(await blob.arrayBuffer());
  } finally {
    bitmap.close();
  }
}
